import clipboardCopy from 'clipboard-copy';
import { useState } from 'react';

export const useCopyToClipboard = () => {
	const [copied, setCopied] = useState(false);

	const copyToClipboard = (snippet) => async () => {
		await clipboardCopy(snippet);

		setCopied(true);
		setTimeout(() => setCopied(false), 5000);
	};

	return {
		copied,
		copyToClipboard,
	};
};
